export default __webpack_public_path__ + "static/media/forward.01338583.svg";